export const CURRENCY_TYPE = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  CAD: '$',
  AUD: '$',
  NZD: '$',
  JPY: '¥',
  BRL: 'R$',
  INR: 'Rs'
}
export const COUNTRY_WISE_CHECK_DETAILS = [
  {
    CountryCode: 'AD',
    CountryName: 'Andorran',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'AE',
    CountryName: 'Utd.Arab Emir.',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'AF',
    CountryName: 'Afghanistan',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'AG',
    CountryName: 'Antigua/Barbuda',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'AI',
    CountryName: 'Anguilla',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 12,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'AL',
    CountryName: 'Albania',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'AM',
    CountryName: 'Armenia',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'AO',
    CountryName: 'Angola',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'AQ',
    CountryName: 'Antarctica',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 15,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'AR',
    CountryName: 'Argentina',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'AS',
    CountryName: 'Samoa, America',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'AT',
    CountryName: 'Austria',
    LengthOfBankAccount: 11,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'AU',
    CountryName: 'Australia',
    LengthOfBankAccount: 9,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 5
  },
  {
    CountryCode: 'AW',
    CountryName: 'Aruba',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'AX',
    CountryName: '',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'AZ',
    CountryName: 'Azerbaijan',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'BA',
    CountryName: 'Bosnia-Herz.',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'BB',
    CountryName: 'Barbados',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'BD',
    CountryName: 'Bangladesh',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'BE',
    CountryName: 'Belgium',
    LengthOfBankAccount: 14,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 15,
    CheckRuleForSwiftBIC: 5
  },
  {
    CountryCode: 'BF',
    CountryName: 'Burkina Faso',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'BG',
    CountryName: 'Bulgaria',
    LengthOfBankAccount: 10,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 8,
    CheckRuleForSwiftBIC: 7
  },
  {
    CountryCode: 'BH',
    CountryName: 'Bahrain',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'BI',
    CountryName: 'Burundi',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'BJ',
    CountryName: 'Benin',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'BL',
    CountryName: 'Blue',
    LengthOfBankAccount: 15,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'BM',
    CountryName: 'Bermuda',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'BN',
    CountryName: 'Brunei Daruss.',
    LengthOfBankAccount: 15,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'BO',
    CountryName: 'Bolivia',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'BQ',
    CountryName: 'Bonaire, Saba',
    LengthOfBankAccount: 15,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'BR',
    CountryName: 'Brazil',
    LengthOfBankAccount: 15,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 5
  },
  {
    CountryCode: 'BS',
    CountryName: 'Bahamas',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'BT',
    CountryName: 'Bhutan',
    LengthOfBankAccount: 15,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'BV',
    CountryName: 'Bouvet Islands',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'BW',
    CountryName: 'Botswana',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'BY',
    CountryName: 'Belarus',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'BZ',
    CountryName: 'Belize',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'CA',
    CountryName: 'Canada',
    LengthOfBankAccount: 15,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 5
  },
  {
    CountryCode: 'CC',
    CountryName: 'Coconut Islands',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'CD',
    CountryName: 'Dem. Rep. Congo',
    LengthOfBankAccount: 15,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'CF',
    CountryName: 'CAR',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'CG',
    CountryName: 'Rep.of Congo',
    LengthOfBankAccount: 15,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'CH',
    CountryName: 'Switzerland',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 5
  },
  {
    CountryCode: 'CI',
    CountryName: 'Cote d\'Ivoire',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'CK',
    CountryName: 'Cook Islands',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'CL',
    CountryName: 'Chile',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 15,
    CheckRuleForSwiftBIC: 5
  },
  {
    CountryCode: 'CM',
    CountryName: 'Cameroon',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'CN',
    CountryName: 'China',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'CO',
    CountryName: 'Colombia',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'CR',
    CountryName: 'Costa Rica',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'CS',
    CountryName: 'Serbia/Monten.',
    LengthOfBankAccount: 15,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'CU',
    CountryName: 'Cuba',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'CV',
    CountryName: 'Cape Verde',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'CW',
    CountryName: 'Curaçao',
    LengthOfBankAccount: 15,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'CX',
    CountryName: 'Christmas Islnd',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'CY',
    CountryName: 'Cyprus',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'CZ',
    CountryName: 'Czech Republic',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 5
  },
  {
    CountryCode: 'DE',
    CountryName: 'Germany',
    LengthOfBankAccount: 14,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'DJ',
    CountryName: 'Djibouti',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'DK',
    CountryName: 'Denmark',
    LengthOfBankAccount: 10,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'DM',
    CountryName: 'Dominica',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'DO',
    CountryName: 'Dominican Rep.',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'DZ',
    CountryName: 'Algeria',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'EC',
    CountryName: 'Ecuador',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'EE',
    CountryName: 'Estonia',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 9,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'EG',
    CountryName: 'Egypt',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'EH',
    CountryName: 'West Sahara',
    LengthOfBankAccount: 15,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'ER',
    CountryName: 'Eritrea',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'ES',
    CountryName: 'Spain',
    LengthOfBankAccount: 10,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'ET',
    CountryName: 'Ethiopia',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'EU',
    CountryName: 'European Union',
    LengthOfBankAccount: 15,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'FI',
    CountryName: 'Finland',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'FJ',
    CountryName: 'Fiji',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'FK',
    CountryName: 'Falkland Islnds',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'FM',
    CountryName: 'Micronesia',
    LengthOfBankAccount: 15,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'FO',
    CountryName: 'Faroe Islands',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'FR',
    CountryName: 'France',
    LengthOfBankAccount: 11,
    CheckRuleForBankAccount: 5,
    LengthOfSwiftBIC: 15,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'GA',
    CountryName: 'Gabon',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'GB',
    CountryName: 'United Kingdom',
    LengthOfBankAccount: 8,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'GD',
    CountryName: 'Grenada',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'GE',
    CountryName: 'Georgia',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'GF',
    CountryName: 'French Guayana',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'GG',
    CountryName: 'Guernsey',
    LengthOfBankAccount: 15,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'GH',
    CountryName: 'Ghana',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'GI',
    CountryName: 'Gibraltar',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'GL',
    CountryName: 'Greenland',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'GM',
    CountryName: 'Gambia',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'GN',
    CountryName: 'Guinea',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'GP',
    CountryName: 'Guadeloupe',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'GQ',
    CountryName: 'Equatorial Guin',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'GR',
    CountryName: 'Greece',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'GS',
    CountryName: 'S. Sandwich Ins',
    LengthOfBankAccount: 15,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'GT',
    CountryName: 'Guatemala',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'GU',
    CountryName: 'Guam',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'GW',
    CountryName: 'Guinea-Bissau',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'GY',
    CountryName: 'Guyana',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'HK',
    CountryName: 'Hong Kong',
    LengthOfBankAccount: 12,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 5
  },
  {
    CountryCode: 'HM',
    CountryName: 'Heard/McDon.Isl',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'HN',
    CountryName: 'Honduras',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'HR',
    CountryName: 'Croatia',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'HT',
    CountryName: 'Haiti',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'HU',
    CountryName: 'Hungary',
    LengthOfBankAccount: 17,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'ID',
    CountryName: 'Indonesia',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'IE',
    CountryName: 'Ireland',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'IL',
    CountryName: 'Israel',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'IM',
    CountryName: 'Isle of Man',
    LengthOfBankAccount: 15,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'IN',
    CountryName: 'India',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 5,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'IO',
    CountryName: 'Brit.Ind.Oc.Ter',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'IQ',
    CountryName: 'Iraq',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'IR',
    CountryName: 'Iran',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'IS',
    CountryName: 'Iceland',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'IT',
    CountryName: 'Italy',
    LengthOfBankAccount: 12,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 15,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'JE',
    CountryName: 'Jersey',
    LengthOfBankAccount: 15,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'JM',
    CountryName: 'Jamaica',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'JO',
    CountryName: 'Jordan',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'JP',
    CountryName: 'Japan',
    LengthOfBankAccount: 7,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 5
  },
  {
    CountryCode: 'KE',
    CountryName: 'Kenya',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'KG',
    CountryName: 'Kyrgyzstan',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'KH',
    CountryName: 'Cambodia',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'KI',
    CountryName: 'Kiribati',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'KM',
    CountryName: 'Comoros',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'KN',
    CountryName: 'St Kitts&Nevis',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'KP',
    CountryName: 'North Korea',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'KR',
    CountryName: 'South Korea',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'KW',
    CountryName: 'Kuwait',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'KY',
    CountryName: 'Cayman Islands',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'KZ',
    CountryName: 'Kazakhstan',
    LengthOfBankAccount: 12,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'LA',
    CountryName: 'Laos',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'LB',
    CountryName: 'Lebanon',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'LC',
    CountryName: 'St. Lucia',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'LI',
    CountryName: 'Liechtenstein',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 15,
    CheckRuleForSwiftBIC: 5
  },
  {
    CountryCode: 'LK',
    CountryName: 'Sri Lanka',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'LR',
    CountryName: 'Liberia',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'LS',
    CountryName: 'Lesotho',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'LT',
    CountryName: 'Lithuania',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'LU',
    CountryName: 'Luxembourg',
    LengthOfBankAccount: 15,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 8,
    CheckRuleForSwiftBIC: 5
  },
  {
    CountryCode: 'LV',
    CountryName: 'Latvia',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'LY',
    CountryName: 'Libya',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'MA',
    CountryName: 'Morocco',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'MC',
    CountryName: 'Monaco',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'MD',
    CountryName: 'Moldova',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'ME',
    CountryName: '',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'MF',
    CountryName: '',
    LengthOfBankAccount: 15,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'MG',
    CountryName: 'Madagascar',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'MH',
    CountryName: 'Marshall Islnds',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'MK',
    CountryName: 'Macedonia',
    LengthOfBankAccount: 0,
    CheckRuleForBankAccount: '',
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'ML',
    CountryName: 'Mali',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'MM',
    CountryName: 'Burma',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'MN',
    CountryName: 'Mongolia',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'MO',
    CountryName: 'Macau',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'MP',
    CountryName: 'N.Mariana Islnd',
    LengthOfBankAccount: 15,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'MQ',
    CountryName: 'Martinique',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'MR',
    CountryName: 'Mauretania',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'MS',
    CountryName: 'Montserrat',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'MT',
    CountryName: 'Malta',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'MU',
    CountryName: 'Mauritius',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'MV',
    CountryName: 'Maldives',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'MW',
    CountryName: 'Malawi',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'MX',
    CountryName: 'Mexico',
    LengthOfBankAccount: 12,
    CheckRuleForBankAccount: 5,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 5
  },
  {
    CountryCode: 'MY',
    CountryName: 'Malaysia',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'MZ',
    CountryName: 'Mozambique',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'NA',
    CountryName: 'Namibia',
    LengthOfBankAccount: 17,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'NC',
    CountryName: 'New Caledonia',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'NE',
    CountryName: 'Niger',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'NF',
    CountryName: 'Norfolk Islands',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'NG',
    CountryName: 'Nigeria',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'NI',
    CountryName: 'Nicaragua',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'NL',
    CountryName: 'Netherlands',
    LengthOfBankAccount: 10,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'NO',
    CountryName: 'Norway',
    LengthOfBankAccount: 11,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'NP',
    CountryName: 'Nepal',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'NR',
    CountryName: 'Nauru',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'NT',
    CountryName: 'NATO',
    LengthOfBankAccount: 15,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'NU',
    CountryName: 'Niue',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'NZ',
    CountryName: 'New Zealand',
    LengthOfBankAccount: 14,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 5
  },
  {
    CountryCode: 'OM',
    CountryName: 'Oman',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'OR',
    CountryName: 'Orange',
    LengthOfBankAccount: 15,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'PA',
    CountryName: 'Panama',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'PE',
    CountryName: 'Peru',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'PF',
    CountryName: 'Frenc.Polynesia',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'PG',
    CountryName: 'Pap. New Guinea',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'PH',
    CountryName: 'Philippines',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'PK',
    CountryName: 'Pakistan',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'PL',
    CountryName: 'Poland',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'PM',
    CountryName: 'St.Pier,Miquel.',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'PN',
    CountryName: 'Pitcairn Islnds',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'PR',
    CountryName: 'Puerto Rico',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'PS',
    CountryName: 'Palestine',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'PT',
    CountryName: 'Portugal',
    LengthOfBankAccount: 11,
    CheckRuleForBankAccount: 2,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'PW',
    CountryName: 'Palau',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'PY',
    CountryName: 'Paraguay',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'QA',
    CountryName: 'Qatar',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'RE',
    CountryName: 'Reunion',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'RO',
    CountryName: 'Romania',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'RS',
    CountryName: 'Serbia',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'RU',
    CountryName: 'Russian Fed.',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 15,
    CheckRuleForSwiftBIC: 5
  },
  {
    CountryCode: 'RW',
    CountryName: 'Rwanda',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'SA',
    CountryName: 'Saudi Arabia',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'SB',
    CountryName: 'Solomon Islands',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'SC',
    CountryName: 'Seychelles',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'SD',
    CountryName: 'Sudan',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'SE',
    CountryName: 'Sweden',
    LengthOfBankAccount: 11,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 5
  },
  {
    CountryCode: 'SG',
    CountryName: 'Singapore',
    LengthOfBankAccount: 10,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'SH',
    CountryName: 'Saint Helena',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'SI',
    CountryName: 'Slovenia',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'SJ',
    CountryName: 'Svalbard',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'SK',
    CountryName: 'Slovakia',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'SL',
    CountryName: 'Sierra Leone',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'SM',
    CountryName: 'San Marino',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'SN',
    CountryName: 'Senegal',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'SO',
    CountryName: 'Somalia',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'SR',
    CountryName: 'Suriname',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'SS',
    CountryName: 'South Sudan',
    LengthOfBankAccount: 15,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'ST',
    CountryName: 'S.Tome,Principe',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'SV',
    CountryName: 'El Salvador',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'SX',
    CountryName: 'Sint Maarten',
    LengthOfBankAccount: 15,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'SY',
    CountryName: 'Syria',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'SZ',
    CountryName: 'Swaziland',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'TC',
    CountryName: 'Turksh Caicosin',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'TD',
    CountryName: 'Chad',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'TF',
    CountryName: 'French S.Territ',
    LengthOfBankAccount: 15,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'TG',
    CountryName: 'Togo',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'TH',
    CountryName: 'Thailand',
    LengthOfBankAccount: 15,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'TJ',
    CountryName: 'Tajikistan',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'TK',
    CountryName: 'Tokelau Islands',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'TL',
    CountryName: 'East Timor',
    LengthOfBankAccount: 15,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'TM',
    CountryName: 'Turkmenistan',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'TN',
    CountryName: 'Tunisia',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'TO',
    CountryName: 'Tonga',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'TP',
    CountryName: 'East Timor',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'TR',
    CountryName: 'Turkey',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'TT',
    CountryName: 'Trinidad,Tobago',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'TV',
    CountryName: 'Tuvalu',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'TW',
    CountryName: 'Taiwan',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'TZ',
    CountryName: 'Tanzania',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'UA',
    CountryName: 'Ukraine',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'UG',
    CountryName: 'Uganda',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'UM',
    CountryName: 'Minor Outl.Isl.',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'UN',
    CountryName: 'United Nations',
    LengthOfBankAccount: 15,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'US',
    CountryName: 'USA',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 9,
    CheckRuleForSwiftBIC: 4
  },
  {
    CountryCode: 'UY',
    CountryName: 'Uruguay',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'UZ',
    CountryName: 'Uzbekistan',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'VA',
    CountryName: 'Vatican City',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'VC',
    CountryName: 'St. Vincent',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'VE',
    CountryName: 'Venezuela',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'VG',
    CountryName: 'Brit.Virgin Is.',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'VI',
    CountryName: 'Amer.Virgin Is.',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'VN',
    CountryName: 'Vietnam',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'VU',
    CountryName: 'Vanuatu',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'WF',
    CountryName: 'Wallis,Futuna',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'WS',
    CountryName: 'Samoa',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'YE',
    CountryName: 'Yemen',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'YT',
    CountryName: 'Mayotte',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'ZA',
    CountryName: 'South Africa',
    LengthOfBankAccount: 17,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  {
    CountryCode: 'ZM',
    CountryName: 'Zambia',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 11,
    CheckRuleForSwiftBIC: 1
  },
  {
    CountryCode: 'ZW',
    CountryName: 'Zimbabwe',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 6,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 0 // This custom rule, only added for rules which are empty string
  },
  { // For Unit Testing only
    CountryCode: 'TEST',
    CountryName: 'Test Country',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 3,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: ''
  },
  { // For Unit Testing only
    CountryCode: 'TEST2',
    CountryName: 'Test Country2',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 3,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 2
  },
  { // For Unit Testing only
    CountryCode: 'TEST3',
    CountryName: 'Test Country3',
    LengthOfBankAccount: 18,
    CheckRuleForBankAccount: 3,
    LengthOfSwiftBIC: 0,
    CheckRuleForSwiftBIC: 3
  }
]
export const CHECK_RULE = [
  {
    ruleId: 0,
    description: 'Allow everything', // This is custom rule only for rules which are empty string
    isNumericalOnly: false,
    isMaxLen: false,
    isExactLen: false,
    isNoSpace: false
  },
  {
    ruleId: 1,
    description: 'Maximum value length, without gaps',
    isNumericalOnly: false,
    isMaxLen: true,
    isExactLen: false,
    isNoSpace: true
  },
  {
    ruleId: 2,
    description: 'Maximum value length, numerical, without gaps',
    isNumericalOnly: true,
    isMaxLen: true,
    isExactLen: false,
    isNoSpace: true
  },
  {
    ruleId: 3,
    description: 'Length to be kept to exactly, without gaps',
    isNumericalOnly: false,
    isMaxLen: false,
    isExactLen: true,
    isNoSpace: true
  },
  {
    ruleId: 4,
    description: 'Length to be kept to exactly, numerical, without gaps',
    isNumericalOnly: true,
    isMaxLen: false,
    isExactLen: true,
    isNoSpace: true
  },
  {
    ruleId: 5,
    description: 'Maximum value length',
    isNumericalOnly: false,
    isMaxLen: true,
    isExactLen: false,
    isNoSpace: false
  },
  {
    ruleId: 6,
    description: 'Maximum value length, numerical',
    isNumericalOnly: true,
    isMaxLen: true,
    isExactLen: false,
    isNoSpace: false
  },
  {
    ruleId: 7,
    description: 'Length to be kept to exactly',
    isNumericalOnly: false,
    isMaxLen: false,
    isExactLen: true,
    isNoSpace: false
  },
  {
    ruleId: 8,
    description: 'Length to be kept to exactly, numerical',
    isNumericalOnly: true,
    isMaxLen: false,
    isExactLen: true,
    isNoSpace: false
  }
]
export const DIRECT_DEPOSIT_PAYMENT = 'DirectDeposit'
export const EDITABLE = 'EDITABLE'
export const IBAN_SUPPORT_COUNTRIES = [
  'AL', 'AD', 'AT', 'AZ', 'BH', 'BE', 'BA', 'BR', 'BG', 'CR', 'HR', 'CY', 'CZ', 'DK', 'DO', 'EE', 'FO', 'FI', 'FR', 'GF', 'PF', 'TF', 'GE', 'DE',
  'GI', 'GR', 'GL', 'GP', 'GT', 'HU', 'IS', 'IE', 'IL', 'IT', 'JO', 'KZ', 'XK', 'KW', 'LV', 'LB', 'LI', 'LT', 'LU', 'MK', 'MT', 'MQ', 'MR', 'MU',
  'YT', 'MD', 'MC', 'ME', 'NC', 'NO', 'PK', 'PS', 'PL', 'PT', 'QA', 'RE', 'RO', 'BL', 'LC', 'MF', 'PM', 'SM', 'ST', 'SA', 'RS', 'SK', 'SI', 'ES',
  'SE', 'CH', 'NL', 'TL', 'TN', 'TR', 'AE', 'GB', 'VI', 'WF'
]
export const MINIMIUM_DEPOSIT_AMOUNT = '25'
export const MINIMIUM_WIRETRANSFER_AMOUNT = '200'
export const ON_HOLD = 'ON_HOLD'
export const PAYPAL_PAYMENT = 'PayPal'
export const PENDING_SETUP = 'PENDING_SETUP'
export const REQUIRED_SETUP = 'REQUIRED_SETUP'
export const WIRE_TRANSFER_PAYMENT = 'WireTransfer'
